import MDEditor, { commands } from '@uiw/react-md-editor';
import rehypeSanitize from 'rehype-sanitize';

export default function MarkdownEditor({
  onChange,
  value,
}: {
  onChange: (value: string) => void;
  value: string;
}) {
  return (
    <MDEditor
      height={215}
      value={value}
      onChange={onChange}
      textareaProps={{ maxLength: 1500 }}
      commands={[commands.bold, commands.italic, commands.link]}
      extraCommands={[
        commands.codeEdit,
        commands.codePreview,
        commands.fullscreen,
      ]}
      previewOptions={{
        rehypePlugins: [[rehypeSanitize]],
      }}
      preview="edit"
    />
  );
}
